import { z } from 'zod'

// Типизированный envelope поверх LiveKit data channels. Транспорт для
// features/call-chat и реакций; форма фиксируется Zod — мусор из канала
// отбраковывается декодером, а не роняет UI.

export const ChatMessageSchema = z.object({
  kind: z.literal('chat'),
  id: z.string().min(1),
  text: z.string().min(1).max(2000),
  sentAt: z.number().int().nonnegative(),
})

export const ReactionSchema = z.object({
  kind: z.literal('reaction'),
  emoji: z.string().min(1).max(16),
  sentAt: z.number().int().nonnegative(),
})

export const DataEnvelopeSchema = z.discriminatedUnion('kind', [ChatMessageSchema, ReactionSchema])

export type ChatMessage = z.infer<typeof ChatMessageSchema>
export type Reaction = z.infer<typeof ReactionSchema>
export type DataEnvelope = z.infer<typeof DataEnvelopeSchema>

const encoder = new TextEncoder()
const decoder = new TextDecoder()

export function encodeEnvelope(envelope: DataEnvelope): Uint8Array {
  return encoder.encode(JSON.stringify(envelope))
}

export function decodeEnvelope(payload: Uint8Array): DataEnvelope | null {
  try {
    const parsed: unknown = JSON.parse(decoder.decode(payload))
    const result = DataEnvelopeSchema.safeParse(parsed)
    return result.success ? result.data : null
  } catch {
    return null
  }
}
